import { render, staticRenderFns } from "./del.vue?vue&type=template&id=260b765c&scoped=true&"
import script from "./del.vue?vue&type=script&lang=js&"
export * from "./del.vue?vue&type=script&lang=js&"
import style0 from "./del.vue?vue&type=style&index=0&id=260b765c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260b765c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
